module.exports = __webpack_public_path__ + "img/Group 31.565a1a3c.png";